// Auto-generated index of all C# components

import Csharp from "./components/Csharp.jsx";
import Csharp_1D_Arrays from "./components/Csharp_1D_Arrays.jsx";
import Csharp_Abstraction from "./components/Csharp_Abstraction.jsx";
import Csharp_Access_Modifiers from "./components/Csharp_Access_Modifiers.jsx";
import Csharp_Add_Two_Numbers from "./components/Csharp_Add_Two_Numbers.jsx";
import Csharp_Arithmetic_Operators from "./components/Csharp_Arithmetic_Operators.jsx";
import Csharp_Arrays from "./components/Csharp_Arrays.jsx";
import Csharp_Assignment_Operators from "./components/Csharp_Assignment_Operators.jsx";
import Csharp_Bitwise_Operators from "./components/Csharp_Bitwise_Operators.jsx";
import Csharp_Bool_Type from "./components/Csharp_Bool_Type.jsx";
import Csharp_Booleans from "./components/Csharp_Booleans.jsx";
import Csharp_Break_Continue from "./components/Csharp_Break_Continue.jsx";
import Csharp_Call_Methods from "./components/Csharp_Call_Methods.jsx";
import Csharp_Certificate from "./components/Csharp_Certificate.jsx";
import Csharp_Class_Members from "./components/Csharp_Class_Members.jsx";
import Csharp_Classes_Objects from "./components/Csharp_Classes_Objects.jsx";
import Csharp_Code_Structure from "./components/Csharp_Code_Structure.jsx";
import Csharp_Comments from "./components/Csharp_Comments.jsx";
import Csharp_Comparison_Operators from "./components/Csharp_Comparison_Operators.jsx";
import Csharp_Compiler from "./components/Csharp_Compiler.jsx";
import Csharp_Constants from "./components/Csharp_Constants.jsx";
import Csharp_Constructors from "./components/Csharp_Constructors.jsx";
import Csharp_Convert_Input from "./components/Csharp_Convert_Input.jsx";
import Csharp_Data_Types from "./components/Csharp_Data_Types.jsx";
import Csharp_Default_Parameters from "./components/Csharp_Default_Parameters.jsx";
import Csharp_Define_Methods from "./components/Csharp_Define_Methods.jsx";
import Csharp_DoWhile from "./components/Csharp_DoWhile.jsx";
import Csharp_Else from "./components/Csharp_Else.jsx";
import Csharp_ElseIf from "./components/Csharp_ElseIf.jsx";
import Csharp_Enums from "./components/Csharp_Enums.jsx";
import Csharp_Examples from "./components/Csharp_Examples.jsx";
import Csharp_Exceptions from "./components/Csharp_Exceptions.jsx";
import Csharp_Exercises from "./components/Csharp_Exercises.jsx";
import Csharp_Explicit_Casting from "./components/Csharp_Explicit_Casting.jsx";
import Csharp_Files from "./components/Csharp_Files.jsx";
import Csharp_Finally from "./components/Csharp_Finally.jsx";
import Csharp_For from "./components/Csharp_For.jsx";
import Csharp_For_Loop from "./components/Csharp_For_Loop.jsx";
import Csharp_Foreach from "./components/Csharp_Foreach.jsx";
import Csharp_Foreach_Arrays from "./components/Csharp_Foreach_Arrays.jsx";
import Csharp_Get_Started from "./components/Csharp_Get_Started.jsx";
import Csharp_Home from "./components/Csharp_Home.jsx";
import Csharp_Identifiers from "./components/Csharp_Identifiers.jsx";
import Csharp_If from "./components/Csharp_If.jsx";
import Csharp_If_Else from "./components/Csharp_If_Else.jsx";
import Csharp_Implicit_Casting from "./components/Csharp_Implicit_Casting.jsx";
import Csharp_Inheritance from "./components/Csharp_Inheritance.jsx";
import Csharp_Interface from "./components/Csharp_Interface.jsx";
import Csharp_Intro from "./components/Csharp_Intro.jsx";
import Csharp_Logical_Operators from "./components/Csharp_Logical_Operators.jsx";
import Csharp_Math from "./components/Csharp_Math.jsx";
import Csharp_Math_Class from "./components/Csharp_Math_Class.jsx";
import Csharp_Math_Methods from "./components/Csharp_Math_Methods.jsx";
import Csharp_Method_Overloading from "./components/Csharp_Method_Overloading.jsx";
import Csharp_Method_Overriding from "./components/Csharp_Method_Overriding.jsx";
import Csharp_Method_Parameters from "./components/Csharp_Method_Parameters.jsx";
import Csharp_Methods from "./components/Csharp_Methods.jsx";
import Csharp_MultiD_Arrays from "./components/Csharp_MultiD_Arrays.jsx";
import Csharp_MultiLine_Comments from "./components/Csharp_MultiLine_Comments.jsx";
import Csharp_Multiple_Variables from "./components/Csharp_Multiple_Variables.jsx";
import Csharp_Named_Arguments from "./components/Csharp_Named_Arguments.jsx";
import Csharp_Numeric_Types from "./components/Csharp_Numeric_Types.jsx";
import Csharp_OOP from "./components/Csharp_OOP.jsx";
import Csharp_Operators from "./components/Csharp_Operators.jsx";
import Csharp_Optional_Parameters from "./components/Csharp_Optional_Parameters.jsx";
import Csharp_Output from "./components/Csharp_Output.jsx";
import Csharp_Polymorphism from "./components/Csharp_Polymorphism.jsx";
import Csharp_Properties from "./components/Csharp_Properties.jsx";
import Csharp_Quiz from "./components/Csharp_Quiz.jsx";
import Csharp_ReadLine from "./components/Csharp_ReadLine.jsx";
import Csharp_Read_Files from "./components/Csharp_Read_Files.jsx";
import Csharp_Return_Values from "./components/Csharp_Return_Values.jsx";
import Csharp_Server from "./components/Csharp_Server.jsx";
import Csharp_SingleLine_Comments from "./components/Csharp_SingleLine_Comments.jsx";
import Csharp_String_Interpolation from "./components/Csharp_String_Interpolation.jsx";
import Csharp_String_Methods from "./components/Csharp_String_Methods.jsx";
import Csharp_Strings from "./components/Csharp_Strings.jsx";
import Csharp_Study_Plan from "./components/Csharp_Study_Plan.jsx";
import Csharp_Switch from "./components/Csharp_Switch.jsx";
import Csharp_Switch_Expression from "./components/Csharp_Switch_Expression.jsx";
import Csharp_Syllabus from "./components/Csharp_Syllabus.jsx";
import Csharp_Syntax from "./components/Csharp_Syntax.jsx";
import Csharp_Ternary from "./components/Csharp_Ternary.jsx";
import Csharp_Text_Types from "./components/Csharp_Text_Types.jsx";
import Csharp_Throw from "./components/Csharp_Throw.jsx";
import Csharp_Try_Catch from "./components/Csharp_Try_Catch.jsx";
import Csharp_Type_Casting from "./components/Csharp_Type_Casting.jsx";
import Csharp_Type_Conversion from "./components/Csharp_Type_Conversion.jsx";
import Csharp_User_Input from "./components/Csharp_User_Input.jsx";
import Csharp_Var from "./components/Csharp_Var.jsx";
import Csharp_Variables from "./components/Csharp_Variables.jsx";
import Csharp_Virtual_Override from "./components/Csharp_Virtual_Override.jsx";
import Csharp_While from "./components/Csharp_While.jsx";
import Csharp_While_Loop from "./components/Csharp_While_Loop.jsx";
import Csharp_Write from "./components/Csharp_Write.jsx";
import Csharp_WriteLine from "./components/Csharp_WriteLine.jsx";
import Csharp_Write_Files from "./components/Csharp_Write_Files.jsx";

const csharpComponentsMap = {
  "<Csharp />": Csharp,
  "<Csharp_1D_Arrays />": Csharp_1D_Arrays,
  "<Csharp_Abstraction />": Csharp_Abstraction,
  "<Csharp_Access_Modifiers />": Csharp_Access_Modifiers,
  "<Csharp_Add_Two_Numbers />": Csharp_Add_Two_Numbers,
  "<Csharp_Arithmetic_Operators />": Csharp_Arithmetic_Operators,
  "<Csharp_Arrays />": Csharp_Arrays,
  "<Csharp_Assignment_Operators />": Csharp_Assignment_Operators,
  "<Csharp_Bitwise_Operators />": Csharp_Bitwise_Operators,
  "<Csharp_Bool_Type />": Csharp_Bool_Type,
  "<Csharp_Booleans />": Csharp_Booleans,
  "<Csharp_Break_Continue />": Csharp_Break_Continue,
  "<Csharp_Call_Methods />": Csharp_Call_Methods,
  "<Csharp_Certificate />": Csharp_Certificate,
  "<Csharp_Class_Members />": Csharp_Class_Members,
  "<Csharp_Classes_Objects />": Csharp_Classes_Objects,
  "<Csharp_Code_Structure />": Csharp_Code_Structure,
  "<Csharp_Comments />": Csharp_Comments,
  "<Csharp_Comparison_Operators />": Csharp_Comparison_Operators,
  "<Csharp_Compiler />": Csharp_Compiler,
  "<Csharp_Constants />": Csharp_Constants,
  "<Csharp_Constructors />": Csharp_Constructors,
  "<Csharp_Convert_Input />": Csharp_Convert_Input,
  "<Csharp_Data_Types />": Csharp_Data_Types,
  "<Csharp_Default_Parameters />": Csharp_Default_Parameters,
  "<Csharp_Define_Methods />": Csharp_Define_Methods,
  "<Csharp_DoWhile />": Csharp_DoWhile,
  "<Csharp_Else />": Csharp_Else,
  "<Csharp_ElseIf />": Csharp_ElseIf,
  "<Csharp_Enums />": Csharp_Enums,
  "<Csharp_Examples />": Csharp_Examples,
  "<Csharp_Exceptions />": Csharp_Exceptions,
  "<Csharp_Exercises />": Csharp_Exercises,
  "<Csharp_Explicit_Casting />": Csharp_Explicit_Casting,
  "<Csharp_Files />": Csharp_Files,
  "<Csharp_Finally />": Csharp_Finally,
  "<Csharp_For />": Csharp_For,
  "<Csharp_For_Loop />": Csharp_For_Loop,
  "<Csharp_Foreach />": Csharp_Foreach,
  "<Csharp_Foreach_Arrays />": Csharp_Foreach_Arrays,
  "<Csharp_Get_Started />": Csharp_Get_Started,
  "<Csharp_Home />": Csharp_Home,
  "<Csharp_Identifiers />": Csharp_Identifiers,
  "<Csharp_If />": Csharp_If,
  "<Csharp_If_Else />": Csharp_If_Else,
  "<Csharp_Implicit_Casting />": Csharp_Implicit_Casting,
  "<Csharp_Inheritance />": Csharp_Inheritance,
  "<Csharp_Interface />": Csharp_Interface,
  "<Csharp_Intro />": Csharp_Intro,
  "<Csharp_Logical_Operators />": Csharp_Logical_Operators,
  "<Csharp_Math />": Csharp_Math,
  "<Csharp_Math_Class />": Csharp_Math_Class,
  "<Csharp_Math_Methods />": Csharp_Math_Methods,
  "<Csharp_Method_Overloading />": Csharp_Method_Overloading,
  "<Csharp_Method_Overriding />": Csharp_Method_Overriding,
  "<Csharp_Method_Parameters />": Csharp_Method_Parameters,
  "<Csharp_Methods />": Csharp_Methods,
  "<Csharp_MultiD_Arrays />": Csharp_MultiD_Arrays,
  "<Csharp_MultiLine_Comments />": Csharp_MultiLine_Comments,
  "<Csharp_Multiple_Variables />": Csharp_Multiple_Variables,
  "<Csharp_Named_Arguments />": Csharp_Named_Arguments,
  "<Csharp_Numeric_Types />": Csharp_Numeric_Types,
  "<Csharp_OOP />": Csharp_OOP,
  "<Csharp_Operators />": Csharp_Operators,
  "<Csharp_Optional_Parameters />": Csharp_Optional_Parameters,
  "<Csharp_Output />": Csharp_Output,
  "<Csharp_Polymorphism />": Csharp_Polymorphism,
  "<Csharp_Properties />": Csharp_Properties,
  "<Csharp_Quiz />": Csharp_Quiz,
  "<Csharp_ReadLine />": Csharp_ReadLine,
  "<Csharp_Read_Files />": Csharp_Read_Files,
  "<Csharp_Return_Values />": Csharp_Return_Values,
  "<Csharp_Server />": Csharp_Server,
  "<Csharp_SingleLine_Comments />": Csharp_SingleLine_Comments,
  "<Csharp_String_Interpolation />": Csharp_String_Interpolation,
  "<Csharp_String_Methods />": Csharp_String_Methods,
  "<Csharp_Strings />": Csharp_Strings,
  "<Csharp_Study_Plan />": Csharp_Study_Plan,
  "<Csharp_Switch />": Csharp_Switch,
  "<Csharp_Switch_Expression />": Csharp_Switch_Expression,
  "<Csharp_Syllabus />": Csharp_Syllabus,
  "<Csharp_Syntax />": Csharp_Syntax,
  "<Csharp_Ternary />": Csharp_Ternary,
  "<Csharp_Text_Types />": Csharp_Text_Types,
  "<Csharp_Throw />": Csharp_Throw,
  "<Csharp_Try_Catch />": Csharp_Try_Catch,
  "<Csharp_Type_Casting />": Csharp_Type_Casting,
  "<Csharp_Type_Conversion />": Csharp_Type_Conversion,
  "<Csharp_User_Input />": Csharp_User_Input,
  "<Csharp_Var />": Csharp_Var,
  "<Csharp_Variables />": Csharp_Variables,
  "<Csharp_Virtual_Override />": Csharp_Virtual_Override,
  "<Csharp_While />": Csharp_While,
  "<Csharp_While_Loop />": Csharp_While_Loop,
  "<Csharp_Write />": Csharp_Write,
  "<Csharp_WriteLine />": Csharp_WriteLine,
  "<Csharp_Write_Files />": Csharp_Write_Files,
};

export default csharpComponentsMap;
